function u(t, o) {
  let e;
  return (...i) => {
    e !== void 0 && clearTimeout(e), e = setTimeout(() => t(...i), o);
  };
}
export {
  u as debounce
};
